/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { Objects } from "../app/common/util/objects";

export const environment = {
  production: false,
  url: {
    base: 'https://iscan-v2.gytni.com/',
    api: 'https://iscan-v2.gytni.com/api', // API 내장서버 주소
    resource: 'https://iscan-v2.gytni.com/files', // 리소스 (파일)서버 주소
    websocket: 'wss://iscan-v2.gytni.com/moni-ws-ep',
  },
  config: {
    testMode: false, // 테스트 데이터 표시여부
    debugMode: Objects.parseBoolean(sessionStorage.getItem('debugMode')),
    apiWaitingTime: 50000, // 타임아웃 대기 시간
    pageSize: 35,
    maxPageSize: 1000,
    unlimitPageSize: 2147483647,
    trendSizeByDay: 13, //차단알림 - 상세페이지 트렌드 표시 일수 (ex) 1주 = 6, 2주 = 13, 3주 = 20, 4주 = 27)
    gridNoDateMessage: '등록된 데이터가 없습니다.',

    /**
     * 집중관리 3D 접속 화면 (Default: FILE)
     * 1 = profile
     * 2 = file
     * 3 = analysis
     * 4 = trace
     * 5 = history
     */
    monitoringViewMode: '2',
  },
  dashboard: {
    trendCount: 30, // 날짜 데이터 표시 수량 (최대 60일)
    chartType: 'bar', // 차트타입 bar, line
  },
};
